var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#233737",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 9.66667H12M8.66667 12H14M6 13.3333V9.2C6 8.07989 6 7.51984 6.21799 7.09202C6.40973 6.71569 6.71569 6.40973 7.09202 6.21799C7.51984 6 8.0799 6 9.2 6H14.8C15.9201 6 16.4802 6 16.908 6.21799C17.2843 6.40973 17.5903 6.71569 17.782 7.09202C18 7.51984 18 8.07989 18 9.2V12.8C18 13.9201 18 14.4802 17.782 14.908C17.5903 15.2843 17.2843 15.5903 16.908 15.782C16.4802 16 15.9201 16 14.8 16H13.1225C12.7065 16 12.4984 16 12.2995 16.0408C12.123 16.0771 11.9521 16.137 11.7917 16.219C11.6108 16.3114 11.4483 16.4413 11.1235 16.7012L9.53317 17.9735C9.25578 18.1954 9.11708 18.3063 9.00036 18.3065C8.89885 18.3066 8.80282 18.2604 8.73949 18.1811C8.66667 18.0898 8.66667 17.9122 8.66667 17.557V17C8.66667 16.4477 8.21481 16.0445 7.66777 15.9686C7.60108 15.9594 7.54028 15.9474 7.48236 15.9319C6.79218 15.7469 6.25308 15.2078 6.06815 14.5176C6 14.2633 6 13.9533 6 13.3333Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.11a33a461767a84e353dfb2ebe6a7cf0.svg";
export { ForwardRef as ReactComponent };